<script setup lang="ts">
// Shell all dialog body components wrap in. Provides chrome (title,
// scrollable body, actions row) and emits `dismiss` when the dialog author
// wants to close without a result. Focus trap, backdrop, Escape, ARIA
// modality, and scroll lock are handled by DialogRoot — not here.

withDefaults(defineProps<{
  title?: string
  size?:  'default' | 'wide' | 'narrow'
}>(), { size: 'default' })

defineEmits<{ dismiss: [] }>()
</script>

<template>
  <div
    class="dialog"
    :class="{
      'dialog--wide':   size === 'wide',
      'dialog--narrow': size === 'narrow',
    }"
    role="dialog"
    aria-modal="true"
    :aria-label="title || undefined"
  >
    <slot name="title">
      <h2 v-if="title" class="dialog-title">{{ title }}</h2>
    </slot>

    <div class="dialog-body">
      <slot />
    </div>

    <div v-if="$slots.actions" class="dialog-actions">
      <slot name="actions" />
    </div>
  </div>
</template>
